export default __webpack_public_path__ + "static/media/Grupo6142.33f154f6.svg";